import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-818b94b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Название сегмента*", -1))
const _hoisted_5 = { class: "flex flex-col fl-1 m-t-8 m-b-8 none" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "small-label"
}, "Тип сегмента*", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-block flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-info-circle info" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Численность аудитории с учетом правил комбинирования сегмента и указанных выборок покажет вам количество уникальных юзеров, попавших в выборку. ")
], -1))
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "form-block fl-50 m-r-13" }
const _hoisted_10 = { class: "flex flex-col fl-1" }
const _hoisted_11 = { class: "flex fl-jc-sb m-b-8 fl-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Точная дата", -1))
const _hoisted_13 = { class: "pi pi-info-circle icon-right" }
const _hoisted_14 = { class: "flex flex-col m-b-8" }
const _hoisted_15 = {
  for: "period",
  class: "small-label"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "period",
  class: "small-label"
}, "Период покупки до", -1))
const _hoisted_19 = { class: "form-block fl-50 m-l-13" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "flex fl-jc-sb m-b-7" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fl-1" }, "Смещение от текущей даты в меньшую сторону", -1))
const _hoisted_23 = { class: "pi pi-info-circle icon-right" }
const _hoisted_24 = { class: "flex flex-col fl-1 m-b-7" }
const _hoisted_25 = { class: "small-label" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "flex flex-col fl-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Окончание периода", -1))
const _hoisted_29 = { class: "form-block" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Фильтр по полу*", -1))
const _hoisted_31 = { class: "gender-filter-section" }
const _hoisted_32 = { class: "female-male-container" }
const _hoisted_33 = { class: "gender-option" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "maleCheckbox",
  class: "gender-checkbox-label"
}, "Мужчины", -1))
const _hoisted_35 = { class: "gender-option" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "femaleCheckbox",
  class: "gender-checkbox-label"
}, "Женщины", -1))
const _hoisted_37 = { class: "form-block" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Фильтр по возрасту*", -1))
const _hoisted_39 = { class: "gender-filter-section" }
const _hoisted_40 = { class: "age-container" }
const _hoisted_41 = { class: "gender-option" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "allAgesCheckbox",
  class: "gender-checkbox-label"
}, "Все", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "age-divider" }, null, -1))
const _hoisted_44 = ["for"]
const _hoisted_45 = { class: "form-block" }
const _hoisted_46 = { class: "flex flex-col" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Категория", -1))
const _hoisted_48 = {
  key: 0,
  class: "form-block"
}
const _hoisted_49 = { class: "flex some-inputs" }
const _hoisted_50 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "period",
  class: "small-label"
}, "Бренд", -1))
const _hoisted_52 = { class: "flex flex-col input-container" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "period",
  class: "small-label"
}, "Магазин", -1))
const _hoisted_54 = { class: "form-block" }
const _hoisted_55 = { class: "flex some-inputs" }
const _hoisted_56 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "total",
  class: "small-label"
}, "Сумма чека от", -1))
const _hoisted_58 = { class: "flex flex-col input-container" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "maxTotal",
  class: "small-label"
}, "Сумма чека до", -1))
const _hoisted_60 = {
  key: 0,
  class: "field-error flex m-t-8"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-exclamation-circle" }, null, -1))
const _hoisted_62 = { class: "text" }
const _hoisted_63 = {
  key: 1,
  class: "info-block flex m-t-8"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-info-circle info" }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Можно указать только нижнюю, только верхнюю или обе границы суммы чека. Пустые поля не учитываются. ", -1))
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = { class: "form-block" }
const _hoisted_68 = { class: "flex some-inputs" }
const _hoisted_69 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "minPurchasesCount",
  class: "small-label"
}, "Кол-во чеков от", -1))
const _hoisted_71 = { class: "flex flex-col input-container" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "maxPurchasesCount",
  class: "small-label"
}, "Кол-во чеков до", -1))
const _hoisted_73 = {
  key: 0,
  class: "field-error flex m-t-8"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-exclamation-circle" }, null, -1))
const _hoisted_75 = { class: "text" }
const _hoisted_76 = {
  key: 1,
  class: "info-block flex m-t-8"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-info-circle info" }, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Можно указать только нижнюю, только верхнюю или обе границы числа покупок. Минимальное значение — 2. ", -1))
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-block alone flex" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "pi pi-info-circle info" }),
    /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
      /*#__PURE__*/_createElementVNode("p", null, " Для расчёта аудитории и сохранения сегмента обязательными полями являются название, период, фильтр по полу и возрасту. Также необходимо выбрать одно или несколько условий выборки (категория, бренд, магазин, стоимость чека, число покупок). Если указать два условия или более, то по ним произойдёт пересечение аудиторий (работает как \"И\"). "),
      /*#__PURE__*/_createElementVNode("p", null, "Перед сохранением сегмента обновите счётчик аудитории.")
    ])
  ])
], -1))

import { ref, watch, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  GENDER_VALUES,
  toggleGenderValue,
  createAgeMappings,
  toggleAgeValue,
} from "@/services/segments/utils";
import { useAgesStore } from "@/store/catalog_data/ages";

import Checkbox from "primevue/checkbox";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import InputInterval from "./InputInterval.vue";
import ChangeSegmentPageDialog from "@/entities/segments/dialogs/ChangeSegmentPageDialog.vue";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import CategoryTreeInput from "@/entities/segments/forms/CategoryTreeInput.vue";
import CalendarInput from "./CalendarInput.vue";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import DecimalNumberInput from "@/shared/forms/DecimalNumberInput.vue";
import Skeleton from "primevue/skeleton";

import { rootGetters } from "@/main";
import { onBeforeRouteLeave } from "vue-router";
import { SegmentFilter, ConditionsGroup } from "@/services/segments/filters";
import {
  hasModifiedConditions,
  validateSegmentBounds,
  validatePurchasesBounds,
  validateTotalRange,
  getCountDisabledReason,
} from "@/services/segments/utils";
import { useSegmentsStore } from "@/store/segments/segments";
import { useCategoriesStore } from "@/store/catalog_data/categories";
import { getFilterWithCategories } from "@/services/utils/Objects";
import {
  isValidPeriod,
  isValidFlexiblePeriod,
} from "@/services/utils/DateValidator";


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentCreateForm',
  props: {
    isLoading: { type: Boolean },
    audienceCount: {},
    segmentCost: {}
  },
  emits: [
  "setCreateButton",
  "setLoading",
  "setFilter",
  "updateIsReadyToCount",
  "updateCountDisabledReason",
  "updateAudienceCount",
  "updateSegmentCost",
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;
const props = __props;

const router = useRouter();
const route = useRoute();
const segmentStore = useSegmentsStore();
const categoryStore = useCategoriesStore();
const agesStore = useAgesStore();
const isLoadingData = ref(false);

// Computed свойства для чекбоксов gender
const maleCheckbox = computed({
  get: () =>
    segment.value.conditionsGroups[0].gender.includes(GENDER_VALUES.MALE),
  set: (value: boolean) => {
    segment.value.conditionsGroups[0].gender = toggleGenderValue(
      segment.value.conditionsGroups[0].gender,
      GENDER_VALUES.MALE
    );
  },
});

const femaleCheckbox = computed({
  get: () =>
    segment.value.conditionsGroups[0].gender.includes(GENDER_VALUES.FEMALE),
  set: (value: boolean) => {
    segment.value.conditionsGroups[0].gender = toggleGenderValue(
      segment.value.conditionsGroups[0].gender,
      GENDER_VALUES.FEMALE
    );
  },
});

// Опции для возраста из store
const ageOptions = computed(() => {
  return agesStore.itemList.map((age) => ({
    value: age.id,
    label: age.type,
  }));
});

// Computed свойство для чекбокса "Все" возрастов
const allAgesCheckbox = computed({
  get: () => {
    if (ageOptions.value.length === 0) return false;
    const allAgeIds = ageOptions.value.map((opt) => opt.value);
    const selectedAges = segment.value.conditionsGroups[0].age;
    return (
      allAgeIds.length > 0 && allAgeIds.every((id) => selectedAges.includes(id))
    );
  },
  set: (value: boolean) => {
    if (value) {
      segment.value.conditionsGroups[0].age = ageOptions.value.map(
        (opt) => opt.value
      );
    } else {
      segment.value.conditionsGroups[0].age = [];
    }
  },
});

const types = ref([
  { name: "Фильтр аудитории", value: "audience_filter" },
  { name: "Вероятность покупки", value: "probability_of_purchase" },
]);

const segment = ref({
  name: "",
  type: types.value[0],
  conditionsGroups: [
    {
      period: {
        start: null,
        end: null,
      },
      flexible_period: {
        start: {
          interval: 0,
          unit: "DAY",
        },
        end: {
          interval: 0,
          unit: "DAY",
        },
      },
      category: [] as any[],
      brand: [] as string[],
      shop: [] as string[],
      gender: [] as number[],
      age: [] as number[],
      total: null as number | null,
      maxTotal: null as number | null,
      minPurchasesCount: null as number | null,
      maxPurchasesCount: null as number | null,
      isFixedDate: true,
      isFlexibleDate: false,
    },
  ],
});

const filter = new SegmentFilter();
const ignoreWatch = ref(false);
const confirmVisible = ref(false);
const blockedRouterButton = ref(false);
const isButtonenabled = computed(() => {
  return (
    hasModifiedConditions(segment.value.conditionsGroups) &&
    validateSegmentBounds(segment.value.conditionsGroups[0]) === null &&
    segment.value.name.length > 0 &&
    !isSegmentSetted.value
  );
});
const countDisabledReason = computed(() =>
  getCountDisabledReason(segment.value.conditionsGroups)
);
const isReadyToCount = computed(() => countDisabledReason.value === null);
const purchasesBoundsError = computed(() =>
  validatePurchasesBounds(segment.value.conditionsGroups[0])
);
const totalRangeError = computed(() =>
  validateTotalRange(segment.value.conditionsGroups[0])
);
const totalRangeFocused = ref(false);
const purchasesRangeFocused = ref(false);
let totalRangeBlurTimer: ReturnType<typeof setTimeout> | null = null;
let purchasesRangeBlurTimer: ReturnType<typeof setTimeout> | null = null;

const showTotalRangeInvalid = computed(
  () => totalRangeError.value != null && !totalRangeFocused.value
);
const showPurchasesRangeInvalid = computed(
  () => purchasesBoundsError.value != null && !purchasesRangeFocused.value
);

function onTotalRangeFocus() {
  if (totalRangeBlurTimer) {
    clearTimeout(totalRangeBlurTimer);
    totalRangeBlurTimer = null;
  }
  totalRangeFocused.value = true;
}

function onTotalRangeBlur() {
  totalRangeBlurTimer = setTimeout(() => {
    totalRangeFocused.value = false;
  }, 120);
}

function onPurchasesRangeFocus() {
  if (purchasesRangeBlurTimer) {
    clearTimeout(purchasesRangeBlurTimer);
    purchasesRangeBlurTimer = null;
  }
  purchasesRangeFocused.value = true;
}

function onPurchasesRangeBlur() {
  purchasesRangeBlurTimer = setTimeout(() => {
    purchasesRangeFocused.value = false;
  }, 120);
}

const isSegmentSetted = computed(() => {
  return Boolean(route.params.id);
});
const toRouter = ref();
const childCategoryTree = ref(null);

watch(
  () => segment.value,
  (newValue) => {
    const ageMappings =
      agesStore.itemList.length > 0
        ? createAgeMappings(agesStore.itemList)
        : undefined;
    if (!ignoreWatch.value) {
      filter.setFilterBySegment(newValue, ageMappings);
    }
    if (!ignoreWatch.value && !isSegmentSetted.value) {
      router.replace({
        name: "segmentCreate",
        query: buildCreateQuery(),
      });
    }
    sendFilterToParent();
  },
  { deep: true }
);

watch(
  isButtonenabled,
  () => {
    emit("setCreateButton", isButtonenabled);
  },
  { immediate: true }
);

onBeforeRouteLeave((to, from) => {
  if (isButtonenabled.value && !confirmVisible.value && !props.isLoading) {
    confirmLeaving();
    toRouter.value = to;
    return false;
  }
  return true;
});

onMounted(async () => {
  if (agesStore.itemList.length === 0) {
    await agesStore.getItems("", [], true, false, 0, 50, true);
  }

  // дублирование
  if (segmentStore.duplicatedSegmentId > 0) {
    setSegmentById(segmentStore.duplicatedSegmentId, true);
    segmentStore.duplicatedSegmentId = 0;
  }

  //сегмент по id для просмотра
  if (isSegmentSetted.value) {
    setSegmentById(parseInt(route.params.id as string), false);
  }

  // сегмент из url
  const filterStr = route.query.filter?.toString();
  const hasFilterFromUrl =
    filterStr && filterStr.length > 2 && filterStr !== "()";

  if (hasFilterFromUrl && filterStr) {
    ignoreWatch.value = true;
    filter.setFilterByStr(filterStr);
    const ageMappings =
      agesStore.itemList.length > 0
        ? createAgeMappings(agesStore.itemList)
        : undefined;
    setFilterGroup(filter.getSegmentConditionsByFilter(undefined, ageMappings));
    applyPurchasesBounds(
      route.query.min_purchases_count,
      route.query.max_purchases_count
    );
    ignoreWatch.value = false;
  } else if (
    route.query.min_purchases_count ||
    route.query.max_purchases_count
  ) {
    ignoreWatch.value = true;
    applyPurchasesBounds(
      route.query.min_purchases_count,
      route.query.max_purchases_count
    );
    ignoreWatch.value = false;
  }

  if (!isSegmentSetted.value && !hasFilterFromUrl) {
    if (
      segment.value.conditionsGroups[0].age.length === 0 &&
      agesStore.itemList.length > 0
    ) {
      segment.value.conditionsGroups[0].age = agesStore.itemList.map(
        (age) => age.id
      );
    }

    if (segment.value.conditionsGroups[0].gender.length === 0) {
      segment.value.conditionsGroups[0].gender = [0, 1];
    }
  }

  if (route.query.type) {
    segment.value.type = types.value.filter(
      (t) => t.value == route.query.type?.toString()
    )[0];
  } else if (route.name == "segmentCreate") {
    if (filter.stringFilter != "()")
      router.replace({
        name: "segmentCreate",
        query: buildCreateQuery(),
      });
    else {
      router.replace({
        name: "segmentCreate",
        query: buildCreateQuery(),
      });
    }
  }

  if (!hasFilterFromUrl) {
    Promise.resolve().then(() => {
      ignoreWatch.value = false;
    });
  }
});

const setFilterGroup = (groups: ConditionsGroup[]) => {
  if (childCategoryTree.value)
    childCategoryTree.value.loadChoosenValues(groups[0].category);
  segment.value.conditionsGroups =
    groups as typeof segment.value.conditionsGroups;
};

function normalizePurchasesCount(
  count: number | string | null | undefined | Array<string | null>
): number | null {
  if (count == null || count === "") return null;
  const raw = Array.isArray(count) ? count[0] : count;
  if (raw == null || raw === "") return null;
  const parsed = typeof raw === "number" ? raw : parseInt(String(raw), 10);
  return Number.isInteger(parsed) && parsed >= 2 ? parsed : null;
}

function applyPurchasesBounds(
  minCount: number | string | null | undefined | Array<string | null>,
  maxCount: number | string | null | undefined | Array<string | null>
) {
  const min = normalizePurchasesCount(minCount);
  const max = normalizePurchasesCount(maxCount);
  filter.filter.min_purchases_count = min;
  filter.filter.max_purchases_count = max;
  if (segment.value.conditionsGroups[0]) {
    segment.value.conditionsGroups[0].minPurchasesCount = min;
    segment.value.conditionsGroups[0].maxPurchasesCount = max;
  }
}

function buildCreateQuery(): Record<string, string> {
  const query: Record<string, string> = {
    type: segment.value.type.value,
  };
  if (filter.stringFilter != "()") {
    query.filter = filter.stringFilter;
  }
  const group = segment.value.conditionsGroups[0];
  const minCount = group.minPurchasesCount;
  const maxCount = group.maxPurchasesCount;
  if (minCount != null && Number.isInteger(minCount) && minCount >= 2) {
    query.min_purchases_count = String(minCount);
  }
  if (maxCount != null && Number.isInteger(maxCount) && maxCount >= 2) {
    query.max_purchases_count = String(maxCount);
  }
  return query;
}

const onTypeChange = () => {
  if (segment.value.type.value == "probability_of_purchase") {
    segment.value.conditionsGroups.forEach((group) => {
      group.brand = [];
      group.shop = [];
    });
  }
};

const setSegmentById = (cloneSegmentId: number, isDuplicate: boolean) => {
  isLoadingData.value = true;
  segmentStore
    .getSegment(cloneSegmentId)
    .then((cloneSegment) => {
      if (cloneSegment) {
        segment.value.name = isDuplicate
          ? cloneSegment.name + " (Копия)"
          : cloneSegment.name;
        segment.value.type = types.value.filter(
          (t) => t.value == cloneSegment.type
        )[0];

        if (cloneSegment.rich && !isDuplicate) {
          emit("updateAudienceCount", cloneSegment.rich.rich ?? null);

          emit(
            "updateSegmentCost",
            cloneSegment.rich.cost
              ? cloneSegment.rich.cost / 100 // Конвертируем копейки в рубли
              : null
          );
        }

        const ageMappings =
          agesStore.itemList.length > 0
            ? createAgeMappings(agesStore.itemList)
            : undefined;
        const groups = filter.getSegmentConditionsByFilter(
          cloneSegment.filter.filters_by_ids,
          ageMappings
        );
        if (cloneSegment.filter.filters_for_db) {
          const dbGroups = filter.getSegmentConditionsByFilter(
            cloneSegment.filter.filters_for_db,
            ageMappings
          );
          if (groups[0] && dbGroups[0]) {
            groups[0].total = dbGroups[0].total;
            groups[0].maxTotal = dbGroups[0].maxTotal;
          }
        }
        setFilterGroup(groups);
        applyPurchasesBounds(
          cloneSegment.filter.min_purchases_count,
          cloneSegment.filter.max_purchases_count
        );
      }
    })
    .finally(() => {
      isLoadingData.value = false;
    });
};

const createSegment = () => {
  const boundsError = validateSegmentBounds(segment.value.conditionsGroups[0]);
  if (
    (segment.value.conditionsGroups[0].isFixedDate &&
      !isValidPeriod(segment.value.conditionsGroups[0].period)) ||
    (segment.value.conditionsGroups[0].isFlexibleDate &&
      !isValidFlexiblePeriod(segment.value.conditionsGroups[0].flexible_period))
  )
    rootGetters.toast.show(
      "warn",
      "Ошибка",
      `Проверьте, что дата начала периода указана и она меньше, чем дата окончания.`
    );
  else if (boundsError) {
    rootGetters.toast.show("warn", "Ошибка", boundsError);
  } else if (
    props.audienceCount === null ||
    props.audienceCount < 100_000 ||
    props.audienceCount > 6_000_000
  ) {
    rootGetters.toast.show(
      "warn",
      "Ошибка",
      `Пересчитайте количество аудитории и убедитесь, что в сегменте не менее 100 тысяч пользователей и не более 6 миллионов.`
    );
  } else {
    const segmentToCreation = {
      name: segment.value.name,
      type: segment.value.type.value,
      filter: getFilterWithCategories(
        filter.filter,
        categoryStore.categoriesMap
      ),
      rich: props.audienceCount,
      cost:
        props.segmentCost !== null
          ? Math.round(props.segmentCost * 100) // Конвертируем рубли в копейки
          : 0,
    };

    emit("setLoading", true);

    segmentStore
      .createSegment(segmentToCreation)
      .then(() => {
        router.push({ name: "listSegments" });
        setTimeout(() => {
          segmentStore.activeFirst = false;
        }, 5000);
      })
      .catch((err) => {
        if (err.response && err.response.status == 403)
          rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
      })
      .finally(() => {
        emit("setLoading", false);
      });
  }
};

const createSegmentFromDialog = () => {
  blockedRouterButton.value = true;
  createSegment();
};

const confirmLeaving = () => {
  blockedRouterButton.value = false;
  confirmVisible.value = true;
};

const exitLeaveDialog = () => {
  router.push(toRouter.value);
};

const sendFilterToParent = () => {
  emit("setFilter", filter.filter);
};

watch(
  isReadyToCount,
  (newValue) => {
    emit("updateIsReadyToCount", newValue);
  },
  { immediate: true }
);

watch(
  countDisabledReason,
  (reason) => {
    emit("updateCountDisabledReason", reason);
  },
  { immediate: true }
);

__expose({
  createSegment,
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                id: "name",
                placeholder: "Введите название",
                modelValue: segment.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((segment.value.name) = $event)),
                disabled: isSegmentSetted.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_unref(Dropdown), {
            id: "type",
            onChange: onTypeChange,
            placeholder: "Выберите тип сегмента",
            modelValue: segment.value.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((segment.value.type) = $event)),
            options: types.value,
            optionLabel: "name",
            "aria-describedby": "type-help",
            disabled: isSegmentSetted.value
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _hoisted_12,
                _withDirectives(_createElementVNode("span", _hoisted_13, null, 512), [
                  [_directive_tooltip, {
                  value:
                    'При выборе этого типа сегмент будет собираться только в рамках указанных дат. Если выбрана дата окончания, то он расчитается один раз и далее обновляться не будет. Если дата окончания не выбрана, то сегмент будет рассчитан и обновлен от даты начала до текущей даты.',
                  class: 'white-tooltip',
                }]
                ])
              ]),
              _createVNode(_unref(InputSwitch), {
                modelValue: segment.value.conditionsGroups[0].isFixedDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((segment.value.conditionsGroups[0].isFixedDate) = $event)),
                disabled: isSegmentSetted.value,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (
                segment.value.conditionsGroups[0].isFlexibleDate =
                  !segment.value.conditionsGroups[0].isFixedDate
              )),
                inputId: "updated"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, [
                _createTextVNode("Период покупки от"),
                (segment.value.conditionsGroups[0].isFixedDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
                default: _withCtx(() => [
                  _createVNode(CalendarInput, {
                    modelValue: segment.value.conditionsGroups[0].period.start,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = 
                  ($event) =>
                    (segment.value.conditionsGroups[0].period.start = $event)
                ),
                    disabled: 
                  isSegmentSetted.value || segment.value.conditionsGroups[0].isFlexibleDate
                
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["is-loading"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
                default: _withCtx(() => [
                  _createVNode(CalendarInput, {
                    modelValue: segment.value.conditionsGroups[0].period.end,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = 
                  ($event) => (segment.value.conditionsGroups[0].period.end = $event)
                ),
                    disabled: 
                  isSegmentSetted.value || segment.value.conditionsGroups[0].isFlexibleDate
                
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["is-loading"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _hoisted_22,
                _withDirectives(_createElementVNode("span", _hoisted_23, null, 512), [
                  [_directive_tooltip, {
                  value:
                    'Смещение `начало периода` означает нижнюю границу периода выборки, `окончание периода` - верхнюю. Например, от минус трех месяцев (начало периода) до минус одного месяца (окончание периода) означает, что если сегодня 1 мая, то данные будут собраны от 1 февраля до 1 апреля. Такой сегмент каждый раз будет обновляться со сдвигом даты относительно текущей. Если дата окончания не указана, то концом периода будет считаться текущая дата. ',
                  class: 'white-tooltip',
                }]
                ])
              ]),
              _createVNode(_unref(InputSwitch), {
                modelValue: segment.value.conditionsGroups[0].isFlexibleDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((segment.value.conditionsGroups[0].isFlexibleDate) = $event)),
                disabled: isSegmentSetted.value,
                inputId: "updated",
                onChange: _cache[7] || (_cache[7] = ($event: any) => (
                segment.value.conditionsGroups[0].isFixedDate =
                  !segment.value.conditionsGroups[0].isFlexibleDate
              ))
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, [
                _createTextVNode("Начало периода"),
                (segment.value.conditionsGroups[0].isFlexibleDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
                default: _withCtx(() => [
                  _createVNode(InputInterval, {
                    disabled: 
                  isSegmentSetted.value || segment.value.conditionsGroups[0].isFixedDate
                ,
                    modelValue: segment.value.conditionsGroups[0].flexible_period.start,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = 
                  ($event) =>
                    (segment.value.conditionsGroups[0].flexible_period.start = $event)
                )
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }, 8, ["is-loading"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
                default: _withCtx(() => [
                  _createVNode(InputInterval, {
                    disabled: 
                  isSegmentSetted.value || segment.value.conditionsGroups[0].isFixedDate
                ,
                    modelValue: segment.value.conditionsGroups[0].flexible_period.end,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = 
                  ($event) =>
                    (segment.value.conditionsGroups[0].flexible_period.end = $event)
                )
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }, 8, ["is-loading"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_unref(Checkbox), {
                modelValue: maleCheckbox.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((maleCheckbox).value = $event)),
                binary: "",
                "input-id": "maleCheckbox",
                disabled: isSegmentSetted.value
              }, null, 8, ["modelValue", "disabled"]),
              _hoisted_34
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_unref(Checkbox), {
                modelValue: femaleCheckbox.value,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((femaleCheckbox).value = $event)),
                binary: "",
                "input-id": "femaleCheckbox",
                disabled: isSegmentSetted.value
              }, null, 8, ["modelValue", "disabled"]),
              _hoisted_36
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_unref(Checkbox), {
                modelValue: allAgesCheckbox.value,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((allAgesCheckbox).value = $event)),
                binary: "",
                "input-id": "allAgesCheckbox",
                disabled: isSegmentSetted.value
              }, null, 8, ["modelValue", "disabled"]),
              _hoisted_42
            ]),
            _hoisted_43,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ageOptions.value, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.value,
                class: "gender-option"
              }, [
                _createVNode(_unref(Checkbox), {
                  "model-value": 
                segment.value.conditionsGroups[0].age.includes(option.value)
              ,
                  "onUpdate:modelValue": (value) => {
                segment.value.conditionsGroups[0].age = _unref(toggleAgeValue)(
                  segment.value.conditionsGroups[0].age,
                  option.value
                );
              },
                  binary: "",
                  "input-id": `ageCheckbox${option.value}`,
                  disabled: isSegmentSetted.value
                }, null, 8, ["model-value", "onUpdate:modelValue", "input-id", "disabled"]),
                _createElementVNode("label", {
                  for: `ageCheckbox${option.value}`,
                  class: "gender-checkbox-label"
                }, _toDisplayString(option.label), 9, _hoisted_44)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          (isLoadingData.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2.2rem",
                class: "mb-2"
              }))
            : _createCommentVNode("", true),
          _createVNode(CategoryTreeInput, {
            class: _normalizeClass([isLoadingData.value ? 'none' : '']),
            modelValue: segment.value.conditionsGroups[0].category,
            ref_key: "childCategoryTree",
            ref: childCategoryTree,
            isSegmentSetted: isSegmentSetted.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = 
            ($event) => (segment.value.conditionsGroups[0].category = $event)
          )
          }, null, 8, ["class", "modelValue", "isSegmentSetted"])
        ])
      ]),
      (segment.value.type.value != 'probability_of_purchase')
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
                  default: _withCtx(() => [
                    _createVNode(CatalogDataBaseInput, {
                      selectType: "brand",
                      isSegmentSetted: isSegmentSetted.value,
                      modelValue: segment.value.conditionsGroups[0].brand,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = 
                ($event) => (segment.value.conditionsGroups[0].brand = $event)
              )
                    }, null, 8, ["isSegmentSetted", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["is-loading"])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
                  default: _withCtx(() => [
                    _createVNode(CatalogDataBaseInput, {
                      selectType: "segment_shop",
                      isSegmentSetted: isSegmentSetted.value,
                      modelValue: segment.value.conditionsGroups[0].shop,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = 
                ($event) => (segment.value.conditionsGroups[0].shop = $event)
              )
                    }, null, 8, ["isSegmentSetted", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["is-loading"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(DecimalNumberInput, {
                  "input-id": "total",
                  modelValue: segment.value.conditionsGroups[0].total,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((segment.value.conditionsGroups[0].total) = $event)),
                  placeholder: "Введите сумму",
                  min: 0,
                  disabled: isSegmentSetted.value,
                  invalid: showTotalRangeInvalid.value,
                  onFocus: onTotalRangeFocus,
                  onBlur: onTotalRangeBlur
                }, null, 8, ["modelValue", "disabled", "invalid"])
              ]),
              _: 1
            }, 8, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(DecimalNumberInput, {
                  "input-id": "maxTotal",
                  modelValue: segment.value.conditionsGroups[0].maxTotal,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((segment.value.conditionsGroups[0].maxTotal) = $event)),
                  placeholder: "Введите сумму",
                  min: 0,
                  disabled: isSegmentSetted.value,
                  invalid: showTotalRangeInvalid.value,
                  onFocus: onTotalRangeFocus,
                  onBlur: onTotalRangeBlur
                }, null, 8, ["modelValue", "disabled", "invalid"])
              ]),
              _: 1
            }, 8, ["is-loading"])
          ])
        ]),
        (totalRangeError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("div", _hoisted_62, _toDisplayString(totalRangeError.value), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_66))
      ]),
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputNumber), {
                  inputId: "minPurchasesCount",
                  modelValue: segment.value.conditionsGroups[0].minPurchasesCount,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((segment.value.conditionsGroups[0].minPurchasesCount) = $event)),
                  placeholder: "Не меньше 2",
                  min: 2,
                  minFractionDigits: 0,
                  maxFractionDigits: 0,
                  useGrouping: false,
                  disabled: isSegmentSetted.value,
                  class: _normalizeClass(['w-full', { 'p-invalid': showPurchasesRangeInvalid.value }]),
                  onFocus: onPurchasesRangeFocus,
                  onBlur: onPurchasesRangeBlur
                }, null, 8, ["modelValue", "disabled", "class"])
              ]),
              _: 1
            }, 8, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _hoisted_72,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputNumber), {
                  inputId: "maxPurchasesCount",
                  modelValue: segment.value.conditionsGroups[0].maxPurchasesCount,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((segment.value.conditionsGroups[0].maxPurchasesCount) = $event)),
                  placeholder: "Не меньше 2",
                  min: 2,
                  minFractionDigits: 0,
                  maxFractionDigits: 0,
                  useGrouping: false,
                  disabled: isSegmentSetted.value,
                  class: _normalizeClass(['w-full', { 'p-invalid': showPurchasesRangeInvalid.value }]),
                  onFocus: onPurchasesRangeFocus,
                  onBlur: onPurchasesRangeBlur
                }, null, 8, ["modelValue", "disabled", "class"])
              ]),
              _: 1
            }, 8, ["is-loading"])
          ])
        ]),
        (purchasesBoundsError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("div", _hoisted_75, _toDisplayString(purchasesBoundsError.value), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_76, _hoisted_79))
      ]),
      _hoisted_80
    ]),
    _createVNode(ChangeSegmentPageDialog, {
      visible: confirmVisible.value,
      blocked: blockedRouterButton.value,
      isSegmentSetted: isSegmentSetted.value,
      onExit: exitLeaveDialog,
      onCreateSegment: createSegmentFromDialog
    }, null, 8, ["visible", "blocked", "isSegmentSetted"])
  ], 64))
}
}

})